export default function ({ context }) {
  const devUrl = 'https://staging18.staging.gb.ru/api/v2/notices'
  const prodUrl = 'https://gb.ru/api/v2/notices'

  const baseUrl = context.$config.isProd ? prodUrl : devUrl

  return {
    async getNotices(page, limit) {
        try {
          const  response = await context.$axios.get(baseUrl,
              {
                useCache: false,
                params: { page, limit }
              })

          return response?.data

        } catch (e) {
          console.warn(e)

          return []
        }
      },

    async getNoticesCount()  {
      try {
        const { data } = await context.$axios.get(`${baseUrl}/counter`)

        return data
      } catch (e) {
        console.warn(e)
      }
    },

    async readNotice(id) {
      try {
        const { data } = await context.$axios.post(`${baseUrl}/${id}/read`)

        return data?.status
      } catch (e) {
        console.warn(e)

        return false
      }
    },

    async readAllNotices() {
      try {
        const { data } = await context.$axios.post(`${baseUrl}/read`)

        return data?.status
      } catch (e) {
        console.warn(e)

        return false
      }
    },

    async getBannerForNotificationPage() {
       try {
         return await context.$axios.get('https://gb.ru/api/ui/v1/banners/right')
       } catch (e) {
         console.warn(e)

         return null
       }
    },

    async getOnboardingStatus() {
      const urlPrefix = context.$config.isProd ? '' : 'gb.dev.'

      try {
        const { shown } = await context.$axios.get(
          `https://${urlPrefix}gb.ru/api/lms/v1/notification/onboarding`
        )

        return shown
      } catch (e) {
        console.warn(e)

        return false
      }
    },

    async setOnboardingStatus(closeMethod) {
      const urlPrefix = context.$config.isProd ? '' : 'gb.dev.'

      try {
        await context.$axios.post(
          `https://${urlPrefix}gb.ru/api/lms/v1/notification/onboarding`,
          {
            closeMethod
          })
      } catch (e) {
        console.warn(e)
      }
    }
  }
}
